export default __webpack_public_path__ + "static/card-4-89a06243f718cc9b6bb76764824261fa.png";